export const isFunction = (val) => typeof val === "function";
